import { ChevronLeftIcon } from '@heroicons/react/24/outline';

import { Heading, Text, Button } from '@restworld/ui-ds-base';
import { cn } from '@restworld/utils-common';

export const InformationHeadLine = ({
  showBackButton,
  title,
  subTitle,
  backButtonClickHandler,
}: {
  showBackButton?: boolean;
  title: string;
  subTitle?: string;
  backButtonClickHandler?: () => void;
}) => (
  <Wrapper data-cy="cv-error-info-head-title-wrapper">
    {showBackButton ? (
      <div className="flex gap-8 w-full items-center">
        <div className="shrink-0">
          <Button variant="tertiary" StartIcon={ChevronLeftIcon} aria-label="back" onClick={backButtonClickHandler} />
        </div>
        <Heading align="center">{title}</Heading>
      </div>
    ) : (
      <Heading testId="information-headline">{title}</Heading>
    )}
    {subTitle ? <Text>{subTitle}</Text> : null}
  </Wrapper>
);
const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex text-center flex-col gap-4 items-center', className)} {...props} />
);
